import React from 'react'
import FeatureDocumentation from '../../components/layouts/docsection'
import SystemStats from "../../images/systemStats.png"
 

const Status = () => {
  const StatusDocs = {
    title: "System Status Management",
    description: "This documentation provides insights into monitoring the operational status of our systems. It serves as a guide for understanding how to interpret system status indicators and their implications for service availability.",
    sections: [
      {
        title: "Overview",
        content: "The system status indicators are essential tools for monitoring the health of our services. They provide real-time feedback on whether the systems are operational or experiencing issues. In this system:",
        image: SystemStats,
        imageAlt: "Systems Status Overview",
        imageCaption: "Figure 1: Comprehensive view of system status indicators.",
        subsections: [
          {
            title: "Status Indicators",
            content: "Each status indicator conveys specific information about system performance:",
            steps: [
              "1. Red Indicator: A red status light signifies that the service is currently down or experiencing critical issues. Immediate attention is required to investigate and resolve the underlying problems to restore service functionality.",
              "2. Green Indicator: A green status light indicates that the system is operational and functioning normally. This means that all services are running as expected and users can access them without any issues.",
            ]
          }
        ]
      }
    ]
  };
  
  return <FeatureDocumentation{...StatusDocs}/>
};

export default Status;
